import {
  Avatar,
  Button,
  Checkbox,
  Flex,
  Icon,
  Input,
  Select,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Stack,
  Box,
  Switch,
} from "@chakra-ui/react";
import NewIcon from "assets/svg/newIcon.svg";
import React, { useMemo, useState } from "react";
import { GrFormNext, GrFormPrevious } from "react-icons/gr";
import {
  FaCheckCircle,
  FaEdit,
  FaTrash,
  FaTimesCircle,
  FaExclamationCircle,
  FaUndoAlt,
  FaArchive,
} from "react-icons/fa";
import {
  TiArrowSortedDown,
  TiArrowSortedUp,
  TiArrowUnsorted,
} from "react-icons/ti";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";

function SearchTable2(props) {
  const {
    columnsData,
    tableData,
    onEdit,
    onDelete,
    onDeliveryDateChange,
    onStatusChange,
  } = props;

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };
  const transformedTableData = useMemo(() => {
    if (!Array.isArray(tableData)) return [];

    return tableData.map((order) => ({
      orderId: order?.orderId || "N/A",
      orderedDate: order?.orderedDate || "N/A",
      deliveryDate: order?.deliveryDate || "N/A",
      orderStatus: order?.orderStatus || "NA",
      name: order?.user?.name || "N/A",
      assignedDriver: order?.driver?.name || "N/A",
      amount: order?.totalAmount ?? "N/A", // Ensure amount is taken correctly
      products:
        order?.products?.map((product) => ({
          productId: product?.id || "N/A",
          // name: product?.name || "N/A",
          qty: product?.qty ?? 0,
          price: product?.price ?? 0,
        })) || [],
    }));
  }, [tableData]);

  console.log("Transformedss", transformedTableData);

  const [selectedOrders, setSelectedOrders] = useState([]);
  const [toggleStates, setToggleStates] = useState({});

  const handleToggle = (orderId) => {
    setToggleStates((prev) => ({
      ...prev,
      [orderId]: !prev[orderId],
    }));
  };

  const handleCheckboxChange = (orderId) => {
    setSelectedOrders(
      (prev) =>
        prev.includes(orderId)
          ? prev.filter((id) => id !== orderId) // Uncheck
          : [...prev, orderId] // Check
    );
  };

  const columns = useMemo(
    () => [
      {
        Header: "ΑΡ. ΠΑΡ.", // Order ID
        accessor: "orderId",
        Cell: ({ row }) => (
          <Flex align="center">
            <Text>{row.original.orderId}</Text>
          </Flex>
        ),
      },
      {
        Header: "ΠΑΡΑΓΓΕΛΙΑ", // Order Date
        accessor: "orderedDate",
        Cell: ({ row }) => (
          <Flex align="center">
            <Text>{formatDate(row.original.orderedDate)}</Text>
          </Flex>
        ),
      },
      {
        Header: "ΠΑΡΑΔΟΣΗ", // Delivery Date
        accessor: "deliveryDate",
        Cell: ({ value }) => formatDate(value),
      },
      {
        Header: "ΚΑΤΑΣΤΑΣΗ", // Order Status in Greek
        accessor: "orderStatus",
        Cell: ({ cell }) => {
          const statusMap = {
            NEW: "Νέα",
            COMPLETED: "Ολοκληρωμένη",
            CANCELLED: "Ακυρωμένη",
          };

          const translatedStatus = statusMap[cell.value] || cell.value;

          return (
            <Flex align="center">
              {cell.value === "NEW" ? (
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ marginRight: "6px" }}
                >
                  <circle cx="10" cy="10" r="10" fill="#3182CE" />
                  <path
                    d="M10 5V11"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <circle cx="10" cy="14" r="1" fill="white" />
                </svg>
              ) : (
                <Icon
                  as={
                    cell.value === "COMPLETED" ? FaCheckCircle : FaTimesCircle
                  }
                  color={cell.value === "COMPLETED" ? "green.400" : "red.400"}
                  w="22px"
                  h="22px"
                  me="6px"
                />
              )}
              <Text>{translatedStatus}</Text>
            </Flex>
          );
        },
      },

      {
        Header: "ΠΕΛΑΤΗΣ", // Name
        accessor: "name",
        Cell: ({ row }) => {
          const fullName = row.original.user.name?.trim() || "";
          const nameParts = fullName.split(" ").filter(Boolean);

          let initials = "";
          if (nameParts.length === 1) {
            initials = nameParts[0][0]?.toUpperCase() || "";
          } else if (nameParts.length >= 2) {
            initials =
              (nameParts[0][0] || "").toUpperCase() +
              (nameParts[nameParts.length - 1][0] || "").toUpperCase();
          }

          return (
            <Flex align="center" maxW="200px">
              {initials && (
                <Box
                  w="30px"
                  h="30px"
                  me="3"
                  borderRadius="full"
                  bg="teal.300"
                  color="white"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  fontSize="sm"
                  fontWeight="bold"
                >
                  {initials}
                </Box>
              )}
              <Text
                isTruncated
                maxW="120px"
                whiteSpace="nowrap"
                overflow="hidden"
                textOverflow="ellipsis"
              >
                {fullName}
              </Text>
            </Flex>
          );
        },
      },
      {
        Header: "ΟΔΗΓΟΣ", // Assigned Driver
        accessor: "assignedDriver",
        Cell: ({ row }) => (
          <Flex align="center">
            <Text>{row.original.driver.name}</Text>
          </Flex>
        ),
      },
      {
        Header: "ΠΟΣΟ", // Amount
        accessor: "totalAmount", // must match data key
        Cell: ({ value }) => {
          const amount = Number(value ?? 0);
          const formatted = new Intl.NumberFormat("el-GR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(amount);

          return (
            <Flex align="center">
              <Text>€{formatted}</Text>
            </Flex>
          );
        },
      },
    ],
    [
      onEdit,
      onDelete,
      onDeliveryDateChange,
      onStatusChange,
      selectedOrders,
      toggleStates,
    ]
  );

  const data = useMemo(() => tableData, [tableData]);

  const tableInstance = useTable(
    {
      columns,
      data,
      globalFilter: (rows, columnIds, filterValue) => {
        return rows.filter((row) => {
          const { original } = row;

          const clientName = original?.user?.name?.toLowerCase() || "";
          const orderId = original?.orderId?.toLowerCase() || "";
          const driverName = original?.driver?.name?.toLowerCase() || "";

          return (
            clientName.includes(filterValue.toLowerCase()) ||
            orderId.includes(filterValue.toLowerCase()) ||
            driverName.includes(filterValue.toLowerCase())
          );
        });
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const createPages = (count) => {
    let arrPageCount = [];

    for (let i = 1; i <= count; i++) {
      arrPageCount.push(i);
    }

    return arrPageCount;
  };

  const {
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    setGlobalFilter,
    state,
    getTableProps,

    gotoPage,
    pageCount,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setPageSize,
  } = tableInstance;
  const { pageIndex, pageSize, globalFilter } = state;
  let dotsBeforeShown = false;
  let dotsAfterShown = false;

  return (
    <Flex direction="column" w="100%">
      {" "}
      {/* Set a height */}
      <Flex
        align={{ sm: "flex-start", lg: "flex-end" }}
        justify={{ sm: "flex-start", lg: "flex-end" }}
        w="100%"
        px="22px"
        mb="36px"
      >
        <Input
          type="text"
          placeholder="Αναζήτηση…"
          minW="75px"
          maxW="175px"
          fontSize="sm"
          _focus={{ borderColor: "teal.300" }}
          value={globalFilter || ""}
          onChange={(e) => setGlobalFilter(e.target.value)}
        />
      </Flex>
      {/* Wrapping table in a scrollable div */}
      <Flex overflowX="auto">
        <Table {...getTableProps()} variant="simple" color="gray.500" mb="24px">
          <Thead>
            {headerGroups.map((headerGroup, index) => (
              <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {headerGroup.headers.map((column, index) => (
                  <Th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    key={index}
                  >
                    <Flex
                      justify="space-between"
                      align="center"
                      fontSize="12px"
                      color="gray.400"
                    >
                      {column.render("Header")}
                      <Icon
                        w="14px"
                        h="14px"
                        color={column.isSorted ? "gray.500" : "gray.400"}
                        as={
                          column.isSorted
                            ? column.isSortedDesc
                              ? TiArrowSortedDown
                              : TiArrowSortedUp
                            : TiArrowUnsorted
                        }
                      />
                    </Flex>
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>
          <Tbody {...getTableBodyProps()}>
            {page.map((row, index) => {
              prepareRow(row);
              return (
                <Tr
                  {...row.getRowProps()}
                  key={index}
                  onClick={() => onEdit(row.original)} // Make row clickable
                  cursor="pointer"
                  _hover={{ backgroundColor: "gray.100" }} // Optional: row hover effect
                >
                  {row.cells.map((cell, index) => (
                    <Td
                      {...cell.getCellProps()}
                      key={index}
                      fontSize="14px"
                      minW="150px"
                    >
                      {cell.render("Cell")}
                    </Td>
                  ))}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </Flex>
      <Flex
        direction={{ sm: "column", md: "row" }}
        justify="space-between"
        align="center"
        px="22px"
        w="100%"
        px={{ md: "22px" }}
      >
        <Text
          fontSize="sm"
          color="gray.500"
          fontWeight="normal"
          mb={{ sm: "24px", md: "0px" }}
        >
          Showing {pageSize * pageIndex + 1} to{" "}
          {pageSize * (pageIndex + 1) <= tableData.length
            ? pageSize * (pageIndex + 1)
            : tableData.length}{" "}
          of {tableData.length} entries
        </Text>
        <Stack direction="row" alignSelf="flex-end" spacing="4px" ms="auto">
          <Button
            variant="no-hover"
            onClick={() => previousPage()}
            transition="all .5s ease"
            w="40px"
            h="40px"
            borderRadius="50%"
            bg="#fff"
            border="1px solid lightgray"
            display={
              pageSize === 5 ? "none" : canPreviousPage ? "flex" : "none"
            }
            _hover={{
              bg: "gray.200",
              opacity: "0.7",
              borderColor: "gray.500",
            }}
          >
            <Icon as={GrFormPrevious} w="16px" h="16px" color="gray.400" />
          </Button>

          {pageSize === 5 ? (
            <NumberInput
              max={pageCount - 1}
              min={1}
              w="75px"
              mx="6px"
              defaultValue="1"
              onChange={(e) => gotoPage(e)}
            >
              <NumberInputField />
              <NumberInputStepper>
                <NumberIncrementStepper onClick={() => nextPage()} />
                <NumberDecrementStepper onClick={() => previousPage()} />
              </NumberInputStepper>
            </NumberInput>
          ) : (
            Array.from({ length: pageCount }).map((_, index) => {
              const isStart = index < 3;
              const isEnd = index >= pageCount - 2;
              const isNearCurrent =
                index === pageIndex ||
                index === pageIndex - 1 ||
                index === pageIndex + 1;

              if (isStart || isEnd || isNearCurrent) {
                return (
                  <Button
                    key={index}
                    variant="no-hover"
                    transition="all .5s ease"
                    onClick={() => gotoPage(index)}
                    w="40px"
                    h="40px"
                    borderRadius="160px"
                    bg={index === pageIndex ? "teal.300" : "#fff"}
                    border="1px solid lightgray"
                    _hover={{
                      bg: "gray.200",
                      opacity: "0.7",
                      borderColor: "gray.500",
                    }}
                  >
                    <Text
                      fontSize="xs"
                      color={index === pageIndex ? "#fff" : "gray.600"}
                    >
                      {index + 1}
                    </Text>
                  </Button>
                );
              }

              if (index === 3 && !dotsBeforeShown) {
                dotsBeforeShown = true;
                return <Text key={`dots-before-${index}`}>...</Text>;
              }

              if (index === pageCount - 3 && !dotsAfterShown) {
                dotsAfterShown = true;
                return <Text key={`dots-after-${index}`}>...</Text>;
              }

              return null;
            })
          )}

          <Button
            variant="no-hover"
            onClick={() => nextPage()}
            transition="all .5s ease"
            w="40px"
            h="40px"
            borderRadius="160px"
            bg="#fff"
            border="1px solid lightgray"
            display={pageSize === 5 ? "none" : canNextPage ? "flex" : "none"}
            _hover={{
              bg: "gray.200",
              opacity: "0.7",
              borderColor: "gray.500",
            }}
          >
            <Icon as={GrFormNext} w="16px" h="16px" color="gray.400" />
          </Button>
        </Stack>
      </Flex>
    </Flex>
  );
}

export default SearchTable2;
